export default __webpack_public_path__ + "static/media/grayBox.e8fcd0c5.png";